import React, { useEffect } from 'react';

import leadsService from 'v2/services/leads/list';

import Details from './Details';
import Filter from './Filter';
import List from './List';

const Leads = () => {
  useEffect(() => {
    return () => leadsService.cleanFilter();
  }, []);

  return (
    <>
      <div id='my-leads' className='flex items-start justify-between'>
        <div className='text-text-heading w-full flex-1 [&_h1]:mb-2! [&_h1]:text-[2rem] [&_h1]:leading-none [&_h1]:font-normal! [&_p]:text-base! [&_p]:leading-5.25! [&_p]:text-[#818b9d]'>
          <h1>Meus Leads</h1>
          <p>
            Acompanhe a evolução de sua lista de Leads (e-mails) trazidos por você como produtor ou por seus afiliados.
          </p>
        </div>
      </div>

      <Filter />
      <Details />
      <List />
    </>
  );
};

export default Leads;
